window.RefreshSession = function (refreshurl, us) {
    $.ajax({
        type: "GET",
        url: refreshurl + "?us=" + us,
        dataType: "text",
        cache: false,
        success: function (msg) {
            if (msg != "OK") {
                var wd = window || document;
                wd.location.reload(true);
            }
        }
    });
};

/* Infragistics functions called in almost every grid */
window.InitializeGrid = function (gridId) {
    // eslint-disable-next-line no-undef
    igtbl_getGridById(gridId);
};

window.MouseOverHeaderColumn = function (gridId, cellId, Type) {
    if (Type == 1) {
        // eslint-disable-next-line no-undef
        var oHtmlElement = igtbl_getElementById(cellId);
        if (oHtmlElement != null) {
            oHtmlElement.style.backgroundColor = "#E0F0F0";
        }
    }
};

window.MouseOutHeaderColumn = function (gridId, cellId, Type) {
    if (Type == 1) {
        // eslint-disable-next-line no-undef
        var oHtmlElement = igtbl_getElementById(cellId);
        if (oHtmlElement != null) {
            oHtmlElement.style.backgroundColor = "LightGrey";
        }
    }
};

window.ToggleAdvancedMode = function (isToggle) {
    // hideOverrideItems = Holder of items that are already hidden with display:none on page load.
    // Such items should not be displayed, even if they are "unhidden" in project settings.
    if (window.hdnAdvancedMode == undefined || window.hdnAdvancedMode == null) {
        return;
    }

    var toggleButton = document.getElementById("btnAdvancedMode");
    var advField = document.getElementById(window.hdnAdvancedMode);
    if (window.hideGUIListAdv && window.hideGUIListAdv.length > 0) {
        if (!isToggle) {
            window.viewSet = true;
        }
        if ((advField.value.toLowerCase() == 'advanced' && isToggle) || (!isToggle && advField.value.toLowerCase() == 'normal')) {
            $(window.hideGUIListAdv).each(function (index) {
                if ($(this).css('display') == 'none') {
                    // Item already hidden, add to "hideOverrideItems" array
                    if ($.inArray($(this), window.hideOverrideItems) == -1) {
                        window.hideOverrideItems.push($(this));
                    }
                }
                else {
                    var $this = $(this);
                    if (this.className == 'act') {
                        var $actTab = $this.parent().prevAll(':visible').has(':visible').first().children().first();
                        if ($actTab.length < 1) {
                            $actTab = $this.parent().nextAll(':visible').has(':visible').first().children().first();
                        }

                        if ($actTab.length > 0) {
                            $("ul.filter_tabs li").removeClass("act"); //Remove any "active" class
                            $("ul.filter_tabs li a").removeClass("act"); //Remove any "active" class
                            $actTab.addClass("act"); //Add "active" class to selected tab
                            $actTab.parent().addClass("act"); //Add "active" class to selected tab

                            var activeTab = $actTab.attr("name"); //Find the href attribute value to identify the active tab + content
                            $("#selectedTab input").val(activeTab);
                            $(".tab_content").hide(); //Hide all tab content
                            // eslint-disable-next-line no-undef
                            FixAddToReports(activeTab);
                            $(activeTab).fadeIn(100);
                        }
                    }
                    else {
                        if ($this.next(':visible:input')) {
                            $this.next(':visible:input').focus();
                        }
                        else if ($this.prev(':visible:input')) {
                            $this.prev(':visible:input').focus();
                        }
                    }
                    $this.addClass('hiddenControl');
                }
            });
            toggleButton.value = 'Show advanced settings';
            toggleButton.title = 'Enter advanced mode to bring up some extra controls';
            advField.value = 'normal';
        }
        else {
            // Show item if not contained in "hideOverrideItems" array
            $(window.hideGUIListAdv).each(function (index) {
                if ($.inArray($(this), window.hideOverrideItems) == -1) {
                    $(this).removeClass('hiddenControl');
                }
            });
            toggleButton.value = 'Hide advanced settings';
            toggleButton.title = 'Hide advanced mode extra controls';
            advField.value = 'advanced';
        }
        toggleButton.className = "ToggleAdvancedMode";
    } else {
        $(toggleButton).remove();
    }
};

window.checkResultsOnlineDuplicate = function () {
    if ($('#iChart').length > 0 || $('#ctl00_CP_iChart').length > 0) {
        var chart = ($('#ctl00_CP_iChart').length > 0) ? $('#ctl00_CP_iChart') : $('#iChart');
        var imgs = chart.parent().find('img');
        if (imgs.length > 1) {
            var len = imgs.eq(1).attr('src').length;
            if (imgs.eq(1).attr('src').substring(0, len) == imgs.eq(0).attr('src').substring(0, len)) {
                imgs.eq(0).hide();
            }
        }
    }
};

window.loadPoweredByImg = function () {
    $('#poweredby > a > img[data-src]:not([src])').attr('src', function () { return $(this).attr('data-src'); });
    $('#poweredby > a > img[data-src]').removeAttr('data-src');
};

try{
	$(window).bind('load', function() {
		Sys.WebForms.PageRequestManager.getInstance().add_endRequest(window.checkResultsOnlineDuplicate);
		window.checkResultsOnlineDuplicate();
		window.loadPoweredByImg();
	});
} catch(Ex){ /* empty */ }